import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { checkPermissions } from 'application/Shared/Components/Core/PermissionCheck';
import { SessionHelper } from 'application/Shared/Helpers';
import { REACT_QUERY_DEV_TOOLS, useHasFeature } from 'featureFlags/src';
import { useSession } from 'hooks/redux/Selectors/session';
import React from 'react';

const ReactQueryDevtoolsProduction = React.lazy(() =>
    import('@tanstack/react-query-devtools/build/modern/production.js').then(
        (d) => ({
            default: d.ReactQueryDevtools
        })
    )
);

/**
 * Renders the Tanstack Devtools.
 * The devtools are loaded conditionally and will load only if granted
 * admin permissions are present.
 *
 * We load the devtools in a lazy way to avoid loading them in production.
 * Source:
 * https://tanstack.com/query/latest/docs/framework/react/devtools#devtools-in-production
 */
export const TanstackDevtools = () => {
    const session = useSession();
    const sessionHelper = new SessionHelper(session);
    const hasPermission = checkPermissions(sessionHelper, [
        { required: ['super_admin', 'global_system_admin'] }
    ]);
    const hasReactQueryDevtools = useHasFeature(REACT_QUERY_DEV_TOOLS);

    return (
        hasPermission &&
        hasReactQueryDevtools && (
            <div className="no-print">
                <ReactQueryDevtools initialIsOpen />
                <React.Suspense fallback={null}>
                    <ReactQueryDevtoolsProduction />
                </React.Suspense>
            </div>
        )
    );
};
